export default __webpack_public_path__ + "static/media/Poppins-Regular.67f2fd42.woff2";